
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/copywriting/product-description",
      function () {
        return require("private-next-pages/copywriting/product-description.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/copywriting/product-description"])
      });
    }
  